export default __webpack_public_path__ + "static/media/icon-unpublished.038225ae.svg";